import React from "react";
import "./ranking.css";
import Menu from "../menu/menu";
import Search from "../search/search";
import TeamFilter from "../UI/TeamFilter/teamFilter";
import RankMember from "../rankMember/rankMember";
import { withRouter } from "react-router-dom";
import LevelSelector from "../UI/levels/levels";

// import DatePicker from "react-datepicker";
import moment from "moment";
// import "react-datepicker/dist/react-datepicker.css";

class Ranking extends React.Component {
  state = {
    showLevelSelector: false,
    selectedMembers: [],
    selectedRankingDate: "",
    selectedLevel: {
      LevelDescription: "Blåt mon bælte m. 1 rød snip",
      LevelGroup: "Junior",
      LevelImage: "levels/B2.png",
      LevelTitle: "5. KYU"
    }
  };

  componentDidMount() {
    this.setState({ selectedRankingDate: moment().format("YYYY-MM-DD") });

    console.log("MEMBERS ComponentDidMount this.props:", this.props);
    this.props.updateFilteredMembers(this.props.searchValue, this.props.teamId,  this.props.status);
  }

  componentDidUpdate() {
    if (this.props.firebaseReady && !this.props.membersLoaded) {
      this.props.loadMembers();
    }
  }

  toggleMember = memberId => {
    console.log("member id:", memberId);
    let selectedMembers = [...this.state.selectedMembers]; 
    const foundMember = this.state.selectedMembers.find(m => m.key == memberId);

    if (foundMember) {
      selectedMembers = selectedMembers.filter(sm => sm.key !== memberId);
    } else {
      selectedMembers.push({ key: memberId });
    }

    this.setState({ selectedMembers: [...selectedMembers] });

    console.log("selected:", selectedMembers);
    console.log("state selected:", this.state.selectedMembers);
  };

  toggleShowLevelSelector = () => {
    // console.log(this.state.showLevelSelector);
    this.setState({ showLevelSelector: !this.state.showLevelSelector });
  };

  selectLevel = level => {
    console.log("selected level is now: ", level);
    this.setState({ selectedLevel: { ...level } });
  };

  handleDayChange = e => {
    console.log(e.target.value);
    this.setState({ selectedRankingDate: e.target.value });
  };


  render() {
    const grantRankButton = this.state.selectedMembers.length > 0
    ? <div className="grant-rank-button" onClick={()=>this.props.addRankToSelectedMembers(this.state.selectedMembers, this.state.selectedLevel, this.state.selectedRankingDate)}>Tildel grad</div>
    : null;

    const header = (
      <div className="header">
        <div className="header-top">
          <img src="/icons/apple-icon-72x72.png" />
          <h3>Gradueringer</h3>
          {grantRankButton}
        </div>
        <div className="header-bottom">
          <Search
            searchValue={this.props.searchValue}
            changed={e => {
              const statusId = this.props.status ? this.props.status : "any"
              // this.props.updateFilteredMembers(e.target.value)} />
              console.log("teamID=", this.props, " target V=", e.target.value);
              this.props.history.push("/ranking/" + this.props.teamId +  `/${statusId}/` + e.target.value);
              this.props.updateFilteredMembers(e.target.value, this.props.teamId,  this.props.status);
            }}
          />
          <TeamFilter
            page="/ranking/"
            searchValue={this.props.searchValue}
            teamId={this.props.teamId}
            changed={this.props.updateFilteredMembers}
          />
        </div>
      </div>
    );

    const membersList = this.props.filteredMembers.map(member => {
      const memberRanks = this.props.ranks.filter(rank => {
        return rank.MemberId == member.ID;
      });

      const memberIsSelected = this.state.selectedMembers.find(sm => sm.key == member.ID);

      return !memberIsSelected ? (
        <RankMember toggleMember={this.toggleMember} member={member} key={member.ID} memberRanks={memberRanks} />
      ) : null;
    });

    const selectedMembers = this.props.filteredMembers.map(member => {
      const memberRanks = this.props.ranks.filter(rank => {
        return rank.MemberId == member.ID;
      });

      const memberIsSelected = this.state.selectedMembers.find(sm => sm.key == member.ID);

      return memberIsSelected ? (
        <RankMember toggleMember={this.toggleMember} member={member} key={member.ID} memberRanks={memberRanks} />
      ) : null;
    });

    const rankingBar = (
      <div className="rankingBar">
        <div className="selected-level" onClick={this.toggleShowLevelSelector}>
          <img className="rank-image" src={"/" + this.state.selectedLevel.LevelImage} />
          <div className="title">
            <div>
              {this.state.selectedLevel.LevelTitle}, {this.state.selectedLevel.LevelGroup}
            </div>
            <div>{this.state.selectedLevel.LevelDescription}</div>
          </div>
        </div>
        <div className="selected-date">
          <label>Gradueringsdato</label>
          <input type="date" value={this.state.selectedRankingDate} onChange={this.handleDayChange} />
        </div>
      </div>
    );

    const levelSelector = this.state.showLevelSelector ? (
      <LevelSelector selectLevel={this.selectLevel} levels={this.props.levels} />
    ) : null;

    return (
      <div className="ranking">
        <Menu currentlyLoggedInUser={this.props.currentlyLoggedInUser} />
        {header}
        {rankingBar}
        <div className="levelSelector-wrapper">{levelSelector}</div>
        <div className="selectors">
          <div className="right">{membersList}</div>
          <div className="left">{selectedMembers}</div>
        </div>
      </div>
    );
  }
}

export default withRouter(Ranking);
